import script from "./ProjectsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsFilter.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsFilter.vue?vue&type=style&index=0&id=b3efbdaa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3efbdaa"]])

export default __exports__